export default __webpack_public_path__ + "static/media/bg.3c2e9a7f.png";